import { Component, OnInit, ElementRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { ApplicationDataCaptureService, FormValidationsService, OutputDetailsService, CommonUtilityService, UtilService, SERVICE_END_POINT, LoaderService, DealPartnerFunctionalityService, AnalyticsService, AuthService } from 'src/app/shared';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/store/state/app.state';
import { Element } from '@angular/compiler';
import * as UserDataConfig from '../../../config/user-data.config';
import { Subscription, Observable } from 'rxjs';
import { YourProductApplication } from 'src/app/model/ngrx/your-product-application.model';
import * as yourProductApplicationActions from '../../../../../store/actions/your-product-application.actions';
import { HttpErrorResponse } from '@angular/common/http';
import { Selectedproductquote } from '../../../../../model/selectedproductquote';
import { SelectedProductQuoteFTRP } from '../../../../../model/selectedProductQuoteFTRP';
import { SelectedProductQuoteCORP } from '../../../../../model/selectedProductQuoteCORP';
import { CurrencyFunctionalityService } from '../../../../../shared/utilities/functionality/currency-functionality.service';
//import { UtilService } from '../../../../../shared';
import * as quoteResultActions from '../../../../../store/actions/quote-result.actions';
import { quoteLevelConstants } from '../../../../../shared/constants/attribute-values.constants';
import { SelectedGMPQuote } from '../../../../../model/selectedGMPQuote';
import { STORE_VAL } from 'src/app/shared/constants/store-val.constant';
import { ConfigLoaderService } from '../../../../../shared/services/api-services/configLoader.service';

@Component({
  selector: 'app-your-product-application',
  templateUrl: './your-product-application.component.html',
  styleUrls: ['./your-product-application.component.scss']
})
export class YourProductApplicationComponent implements OnInit {
  yourProductApplicationForm: UntypedFormGroup;


  public contentData;
  protected cmsProductChoice;
  protected resultQuote: {};
  public selectedProductCode: string;
  protected selectedProductName: string;
  public keyFeatureURL: any;
  public keyFeatureSize: any;
  public termsAndConditionsURL: any;
  public termsAndConditionsSize: any;
  public scamsLeafletURL: any;
  public scamsLeafletSize: any;
  public selectedProductTermsAndConditions: any;
  isViewOnly = false;
  viewSummaryFlag = false;
  cmsData1: any;
  declarationSection: any;
  formCompletionSection: any;
  subInfo: any;
  sourceFlag: any;
  protected isAgreeSelected = false;
  public AgreeErrorValidatorFlag: any;
  protected isSignSelected = false;
  public signErrorValidatorFlag: any;
  public afterApplyDetail = UserDataConfig.ElementsConfig;
  public productDetailsSection: any;
  notProvidedText: string;
  yourProductApplication: YourProductApplication;
  subscripSaveProgress: Subscription;
  subscriptn: Subscription;
  subscriptnsavedquote: Subscription;
  subscripLogout: Subscription;
  subappstore: Subscription;
  subquoteResultstore: Subscription;
  subproductstore: Subscription;
  quoteRefNoStore: Subscription;
  applicationRefNumber: string;
  chkAgreeValue = false;
  private responseApplicationData: any[];
  loadingFlag = false;
  loginDetail: any;
  Selectedproductquote: Selectedproductquote;
  SelectedProductQuoteFTRP: SelectedProductQuoteFTRP;
  SelectedProductQuoteCORP: SelectedProductQuoteCORP;
  cmsDataProductQuote: any;
  generalConstants: any;
  getQueryParameters;
  taxFreeCashAmount;
  extTaxFreeCashAmount;
  totalTaxFreeCash;
  applyForHo = false;
  isHOView = false;
  private CMSData;
  lifestyleStatementFlag = false;
  selectedProductInfo;
  submitCTAlabel;
  backToMyQuotesCTA;
  selectedGMP: SelectedGMPQuote;
  constructor(private router: Router,
    private fb: UntypedFormBuilder, private outputDetailsService: OutputDetailsService,
    private activatedRoute: ActivatedRoute,
    private applicationDatacaptureService: ApplicationDataCaptureService,
    public el: ElementRef,
    private store: Store<AppState>, private utilService: UtilService,
    private authService: AuthService,
    private loaderService: LoaderService,
    private dealPartnerFunctionalityService: DealPartnerFunctionalityService,
    private analyticsService: AnalyticsService, private configLoaderService: ConfigLoaderService) {

    // tslint:disable-next-line: max-line-length
    this.isViewOnly = this.activatedRoute.snapshot.queryParamMap.get('view') ? true : false;
    this.contentData = this.activatedRoute.snapshot.data.contentData.yourProductApplication;
    this.cmsProductChoice = this.activatedRoute.snapshot.data.contentData.productChoice;
    this.cmsData1 = this.activatedRoute.snapshot.data.contentData.productQuoteComparison;
    this.cmsDataProductQuote = JSON.parse(JSON.stringify(this.activatedRoute.snapshot.data.contentData.productQuote));
    this.notProvidedText = this.activatedRoute.snapshot.data.contentData.pleaseConfirmDetails.notProvided;
    this.generalConstants = this.activatedRoute.snapshot.data.contentData.generalConstants;

    this.subproductstore = store.select(STORE_VAL.your_product_application).subscribe(res => {
      if (res && res.length > 0) {
        this.yourProductApplication = res[0];
      }
    });
    this.quoteRefNoStore = this.store.select(STORE_VAL.ref_no).subscribe((val) => {
      if (val.length > 0) {
        this.applicationRefNumber = val[0].applicationRefNumber;
        // this.formSessionId = val[0]['formSessionId'];
      }
    });
    this.subappstore = store.select(STORE_VAL.application_data_response).subscribe((val) => {
      if (val && val.length > 0) {
        this.responseApplicationData = val[0];
        if (this.isViewOnly) {
          this.afterApplyDetail.buttonConfigProductApplication.label = 'Back to my quotes';
        }
      }
    });

    // this.quoteDatacaptureService.getGuaranteedQuote(this.responseApplicationData['quoteRefs'][0]).subscribe(res => {
    //   this.store.dispatch(new quoteResultActions.RemoveQuoteResult(0));
    //   this.store.dispatch(new quoteResultActions.AddQuoteResult(res));
    // });

    // login store data
    this.store.select(STORE_VAL.loggedin_detail).subscribe(res => {
      if (res.length > 0) {
        this.loginDetail = res[0];
      }
    });

    this.activatedRoute.queryParams.subscribe(params => {
      this.getQueryParameters = params;
    });
    this.activatedRoute.data
      .subscribe((data) => {
        this.CMSData = data.cmsJson;
      });
  }

  ngOnInit(): void {
    if (this.getQueryParameters && this.getQueryParameters['applcationRefNo']) {
      this.isHOView = true;

      this.applicationDatacaptureService.viewApplicationHO(this.getQueryParameters['applcationRefNo']);
    }
    this.subquoteResultstore = this.store.select(STORE_VAL.quote_result).subscribe(res => {
      if (res.length > 0) {
        this.isViewOnly = this.activatedRoute.snapshot.queryParamMap.get('view') ? true : false;
        this.resultQuote = res[0];
        // tslint:disable-next-line: max-line-length
        this.applyForHo = this.activatedRoute.snapshot.queryParamMap.get('quoteRefNo') ? true : false;
        this.afterApplyDetail.buttonConfigProductApplication.label = 'Submit';
        this.productDetailsSection = this.contentData.productDetails;
        this.declarationSection = this.contentData.declarationSection;
        this.subInfo = this.declarationSection['data'][0]['subInformationList'][1]['subHeading-Info'][2]['subInfoList'];
        this.formCompletionSection = this.contentData.formCompletionSection;

        // capturing the selected product code in Quote Journey
        if (this.resultQuote) {
          this.selectedProductCode = this.cmsProductChoice.products.find(p => p.productCode === this.resultQuote['product']).productCode;
          this.selectedProductName = this.cmsProductChoice.products.find(p => p.productCode === this.resultQuote['product']).productName;
          // set header name
          this.contentData.header = this.contentData.header.replace('{}', this.selectedProductName);
          // tslint:disable-next-line:max-line-length
          this.contentData.introduction = this.contentData.introduction.replace('{}', this.selectedProductCode === 'C' ? this.contentData.annuityText : this.contentData.planText);
          // tslint:disable-next-line:max-line-length
          this.declarationSection['data'][0]['heading-info'][1] = this.declarationSection['data'][0]['heading-info'][1].replace('{}', this.selectedProductName);
          // tslint:disable-next-line:max-line-length
          this.declarationSection['data'][0]['heading-info'][2] = this.declarationSection['data'][0]['heading-info'][2].replace('{}', this.selectedProductName);
          this.subInfo[1] = this.subInfo[1].replace('{}', this.selectedProductName);
          // Deal Partners and Non-Deal Partners differentiation
          if (this.resultQuote['source'] === 'I' || this.resultQuote['source'] === 'B') {
            this.sourceFlag = 'NonDP';
          } else {
            this.sourceFlag = 'DP';
          }
          this.taxFreeCashAmount = (this.resultQuote['totalTaxFreeCashAmount']) ? this.resultQuote['totalTaxFreeCashAmount'] : 0;
          this.extTaxFreeCashAmount = (this.resultQuote['totalExtTaxFreeCashAmount']) ? this.resultQuote['totalExtTaxFreeCashAmount'] : 0;
          this.totalTaxFreeCash = this.taxFreeCashAmount + this.extTaxFreeCashAmount;

          this.quoteData(); // capture quote data to implement personaised quote pdf

          /*defect 3243*/
          if (this.responseApplicationData['secondLife'] === null ||
            (this.responseApplicationData['secondLife'] !== null && this.responseApplicationData['secondLife']['dateOfBirth'] === null)) {
            if (this.selectedProductCode === 'C') {
              this.lifestyleStatementFlag = true;
            } else {
              this.lifestyleStatementFlag = false;
            }
          }

        }
        this.selectedProductInfo = this.cmsProductChoice.products
          .find(response => response.productCode === this.selectedProductCode);
        this.GetCMSDataServiceMapper();
        this.getProductKeyFeatureUrlandSize();
        this.getTermsAndConditionsUrlandSize();
        this.getScamsLeafletUrlandSize();
        if (this.yourProductApplication) {
          this.setFormValues();
        } else {
          this.userFormData();
        }
        // tslint:disable-next-line:max-line-length
        this.subscripSaveProgress = this.applicationDatacaptureService.invokeSaveFunction.subscribe(() => {
          this.saveProgress();
        });
        // tslint:disable-next-line:max-line-length
        this.subscripLogout = this.applicationDatacaptureService.invokeLogoutFunction.subscribe(() => {
          this.saveAfterLogout();
        });
        this.updateVisibility(); // update visibility of product details section
        if (this.getQueryParameters && this.getQueryParameters['applcationRefNo']) {
          this.applicationDatacaptureService.resumeApplicationFromHO(this.getQueryParameters['applcationRefNo'], true);
        }
        if (this.applyForHo) {
          this.isViewOnly = true;
        }
      }
    });
    this.analyticsService.orderTrack({ internalReferenceDCJ: this.responseApplicationData['quoteRefs'][0], applicationReferenceDCJ:this.responseApplicationData['applicationId']});
  }

  userFormData = () => {
    this.afterApplyDetail.buttonConfigProductApplication.label = this.submitCTAlabel;
    this.yourProductApplicationForm = this.fb.group({
      chkPost: [null],
      chkEmail: [null],
      chkText: [null],
      chkTelephone: [null],
      chkOnline: [null],
      chkAgree: [null],
      chkSign: [null]
    });
  }
  setFormValues = () => {
    if (this.isViewOnly) {
      this.afterApplyDetail.buttonConfigProductApplication.label = this.backToMyQuotesCTA;
    }
    this.yourProductApplicationForm = this.fb.group({
      chkEmail: this.yourProductApplication.updatesVia.email ? this.yourProductApplication.updatesVia.email : null,
      chkPost: this.yourProductApplication.updatesVia.post ? this.yourProductApplication.updatesVia.post : null,
      chkText: this.yourProductApplication.updatesVia.text ? this.yourProductApplication.updatesVia.text : null,
      chkTelephone: this.yourProductApplication.updatesVia.telephone ? this.yourProductApplication.updatesVia.telephone : null,
      chkAgree: [this.yourProductApplication.chkAgree ? this.yourProductApplication.chkAgree : null],
      chkSign: [this.yourProductApplication.chkSign ? this.yourProductApplication.chkSign : null],
      chkOnline: [this.yourProductApplication.updatesVia.pom ? this.yourProductApplication.updatesVia.pom : null]
    });

    if (this.yourProductApplicationForm && this.isHOView) {
      this.yourProductApplicationForm.get('chkAgree').setValue(true);
    }
  }
  // Capturing URL and Size of Key Features
  getProductKeyFeatureUrlandSize() {
    const selectedDocument = this.selectedProductInfo.documentLink.find(res => res.key === 'keyFeatures')
      .urlArray.find(res => res.fundingSource === this.resultQuote['source']);
    this.keyFeatureSize = selectedDocument.size;
    this.keyFeatureURL = selectedDocument.url;
  }

  // Capturing URL and Size of Terms&Conditions
  getTermsAndConditionsUrlandSize() {
    this.selectedProductTermsAndConditions = this.cmsProductChoice.products
      .find(response => response.productCode === this.selectedProductCode);
    const selectedLink = this.selectedProductTermsAndConditions.documentLink.find(res => res.name === 'Terms and conditions');
    // .Terms.find(res => res.name === "T&Cs")
    this.termsAndConditionsURL = selectedLink.url;
    this.termsAndConditionsSize = selectedLink.size;
  }

  // Capturing URL and Size of PensionScams
  getScamsLeafletUrlandSize() {
    this.scamsLeafletURL = this.cmsProductChoice.pensionScams.url;
    this.scamsLeafletSize = this.cmsProductChoice.pensionScams.size;
  }
  //capturing size of personalised quote pdf
  getYourPersonalisedQuoteSize() {
    return this.cmsData1.pdf1;
  }
  // able to view the application summary modal
  viewSummary() {
    this.analyticsService.eventTrack({
      type: 'ButtonClick',
      name: 'view summary',
      pageID: this.utilService.getScreenNameFromURL(this.router.url)
    });
    this.viewSummaryFlag = true;
  }
  // close the applciation summary modal
  cancelCloseModal() {
    this.viewSummaryFlag = false;
    // set button label
    if (this.isViewOnly) {
      this.afterApplyDetail.buttonConfigProductApplication.label = this.backToMyQuotesCTA;
    } else {
      this.afterApplyDetail.buttonConfigProductApplication.label = this.submitCTAlabel;
    }
  }

  handlePDFDetails(value: number) {
    const pdfName = value === 1 ? 'key features' : (value === 2 ? 'terms and conditions'
      : (value === 3 ? 'pension scams' : 'your personalised quote'));
    this.analyticsService.eventTrack({
      type: 'Download',
      name: pdfName,
      pageID: this.utilService.getScreenNameFromURL(this.router.url)
    });
    switch (value) {
      case 1:
        window.open(this.keyFeatureURL, '_blank');
        break;
      case 2:
        window.open(this.termsAndConditionsURL, '_blank');
        break;
      case 3:
        window.open(this.scamsLeafletURL, '_blank');
        break;
      case 4: // personalsied quote
        const productQuote = this.selectedProductCode === 'C' ? this.Selectedproductquote :
          (this.selectedProductCode === 'H' ? this.SelectedProductQuoteFTRP : this.SelectedProductQuoteCORP);
        this.openPersonalisedQuote(productQuote);
        break;
    }
  }
  // method to  open personalised quote 
  openPersonalisedQuote = (productQuote) => {
    if (this.responseApplicationData && this.responseApplicationData['triggeredBy'] === 'HOuser') {
      const recipientName = '';
      const inputParam = {
        addressLine1: '',
        addressLine2: '',
        addressLine3: '',
        addressLine4: '',
        countryCode: '',
        lifeTimeAllowanceFlag: 'N',
        isSendToTrustee: 'N',
        thirdParty: { partyType: '', address: {} },
        outputMethod: this.cmsDataProductQuote.localPrint,
        packCode: '',
        packCodeDescription: '',
        padsRefNo: (productQuote && productQuote.padsRefNo) ? productQuote.padsRefNo : '',
        quoteRef: (productQuote && productQuote.quoteRefNo) ? productQuote.quoteRefNo : '',
        postcode: '',
        recipientName,
        isGMP: quoteLevelConstants.radioToggleYesNo.yes
      };
      this.backendCallforKFI(inputParam);
    } else {
      if (this.loginDetail && this.loginDetail.customer) {
        const customerDetail = this.loginDetail.customer;
        const recipientName = (customerDetail.title ? customerDetail.title + ' ' : '') +
          (customerDetail.forename ? customerDetail.forename + ' ' : '') +
          (customerDetail.middleName ? customerDetail.middleName + '  ' : '') +
          (customerDetail.surname ? customerDetail.surname : '');
        const inputParam = {
          addressLine1: customerDetail.address ? customerDetail.address.line1 : '',
          addressLine2: customerDetail.address ? customerDetail.address.line2 : '',
          addressLine3: customerDetail.address ? customerDetail.address.line3 : '',
          addressLine4: customerDetail.address ? customerDetail.address.line4 : '',
          countryCode: customerDetail.address ? customerDetail.address.countryCode : '',
          lifeTimeAllowanceFlag: 'N',
          isSendToTrustee: 'N',
          thirdParty: { partyType: '', address: {} },
          outputMethod: this.cmsDataProductQuote.localPrint,
          packCode: '',
          packCodeDescription: '',
          padsRefNo: (productQuote && productQuote.padsRefNo) ? productQuote.padsRefNo : '',
          quoteRef: (productQuote && productQuote.quoteRefNo) ? productQuote.quoteRefNo : '',
          postcode: customerDetail.address ? customerDetail.address.postcode : '',
          recipientName,
          isGMP: quoteLevelConstants.radioToggleYesNo.no
        };
        this.backendCallforKFI(inputParam);
      }
    }
  }

  backendCallforKFI(inputParam) {
    this.outputDetailsService.generateRiskWarning(inputParam).subscribe((data: any) => {
      const file = new Blob([data], { type: 'application/pdf' });

      const nav = (window.navigator as any); 

      if (nav.msSaveOrOpenBlob) {
        nav.msSaveOrOpenBlob(file, 'Quote ref' + inputParam.padsRefNo + '.pdf');
      } else {
        const fileURL = URL.createObjectURL(file);
        window.open(fileURL);
      }
      this.store.dispatch({ type: 'LOADING_ICON', loadingIcon: false });
    }, (err: HttpErrorResponse) => {
      if (err.error instanceof Error) {
        //console.log('Client-side error occured.');
      } else {
        //console.log(err);
      }
    });
  }

  prepareListForCheckboxStd(updatesVia: any[]) {
    const updatesList = [];
    updatesVia.forEach(element => {
      updatesList.push(element.text);
    });
    return updatesList;
  }
  onAgreeCheckChange(e) {
    this.isAgreeSelected = e.target.checked;
    this.AgreeErrorValidatorFlag = !this.isAgreeSelected;
  }
  //capturing radio button
  selectedUpdatesList(listchk) {
    //console.log(listchk);
    // not being used
  }
  saveProgress() {
    // Onclick of Save Progress button logic
    this.saveFormValues();
    this.applicationDatacaptureService.postApplicationDataCapture(false).subscribe();
  }
  saveAfterLogout() {
    // Onclick of Logout button logic
    this.saveFormValues();
    this.subscriptn = this.applicationDatacaptureService.postApplicationDataCapture(false).subscribe(res => {
      this.authService.logout();
    });
  }
  saveFormValues() {
    // To save all fields values into the store
    this.store.dispatch(new yourProductApplicationActions.RemoveYourProductApplication(0));
    this.store.dispatch(new yourProductApplicationActions.AddYourProductApplication({
      chkAgree: this.yourProductApplicationForm.controls.chkAgree.value ? true : null,
      chkSign: this.yourProductApplicationForm.value.chkSign ? this.yourProductApplicationForm.value.chkSign : null,
      updatesVia: {
        email: this.yourProductApplicationForm.controls.chkEmail.value,
        post: this.yourProductApplicationForm.controls.chkPost.value,
        text: this.yourProductApplicationForm.controls.chkText.value,
        telephone: this.yourProductApplicationForm.controls.chkTelephone.value,
        pom: this.yourProductApplicationForm.controls.chkOnline.value
      }
    }));
  }
  // tslint:disable-next-line:use-life-cycle-interface
  ngOnDestroy() {
    // OnDestroy unsubscribing the subcriptions
    if (this.subscriptn) {
      this.subscriptn.unsubscribe();
    }
    if (this.subscriptnsavedquote) {
      this.subscriptnsavedquote.unsubscribe();
    }
    if (this.subscripSaveProgress) {
      this.subscripSaveProgress.unsubscribe();
    }
    if (this.subscripLogout) {
      this.subscripLogout.unsubscribe();
    }
    if (this.subappstore) {
      this.subappstore.unsubscribe();
    }
    if (this.subproductstore) {
      this.subproductstore.unsubscribe();
    }
    if (this.quoteRefNoStore) {
      this.quoteRefNoStore.unsubscribe();
    }
    if (this.subquoteResultstore) {
      this.subquoteResultstore.unsubscribe();
    }
  }
  submit() {
    let paymentFreq: string;
    paymentFreq = this.resultQuote['paymentFrequency'] && this.resultQuote['paymentFrequency'] === "M" ? 'Monthly' : (this.resultQuote['paymentFrequency'] && this.resultQuote['paymentFrequency'] === "Y" ? 'Yearly' :
      (this.resultQuote['paymentFrequency'] && this.resultQuote['paymentFrequency'] === "H" ? 'Half yearly' : (this.resultQuote['paymentFrequency'] && this.resultQuote['paymentFrequency'] === "Q" ? 'Quarterly' : null)));

    this.analyticsService.eventTrack({
      type: 'ButtonClick',
      name: 'submit application',
      pageID: this.utilService.getScreenNameFromURL(this.router.url),
      annuityTypeApply: paymentFreq,
      annuityApply: this.resultQuote['annualIncome'] && this.resultQuote['paymentFrequency'] === "Y" ? '£' + Math.round(this.resultQuote['annualIncome'] * 100) / 100 : (this.resultQuote['annualIncome'] && this.resultQuote['paymentFrequency'] === "M" ? '£' + Math.round((this.resultQuote['annualIncome'] / 12) * 100) / 100 :
        (this.resultQuote['annualIncome'] && this.resultQuote['paymentFrequency'] === "Q" ? '£' + Math.round((this.resultQuote['annualIncome'] / 4) * 100) / 100 : (this.resultQuote['annualIncome'] && this.resultQuote['paymentFrequency'] === "H" ? '£' + Math.round((this.resultQuote['annualIncome'] / 2) * 100) / 100 : null))),
      pensionPotApply: this.resultQuote['pensionFund'] ? '£' + this.resultQuote['pensionFund'] : null,
      incomeApply: this.resultQuote['paymentFrequency'] && this.resultQuote['paymentAdvance'] && this.resultQuote['paymentAdvance'] === "A" ? paymentFreq + ' / ' + 'In advance' :
        (this.resultQuote['paymentFrequency'] && this.resultQuote['paymentAdvance'] && this.resultQuote['paymentAdvance'] === "B" ? paymentFreq + ' / ' + 'In arrears' : null),
      paymentPeriodApply: this.resultQuote['guaranteedTerm'] ? this.resultQuote['guaranteedTerm'] + ' years' : null,
      orderRef: this.resultQuote['quoteRefNo'] ? this.resultQuote['quoteRefNo'] : null,
      email: this.yourProductApplicationForm.controls.chkEmail.value ? 'Yes' : 'No',
      post: this.yourProductApplicationForm.controls.chkPost.value ? 'Yes' : 'No',
      sms: this.yourProductApplicationForm.controls.chkText.value ? 'Yes' : 'No',
      telephone: this.yourProductApplicationForm.controls.chkTelephone.value ? 'Yes' : 'No',
      personalised: this.yourProductApplicationForm.controls.chkOnline.value ? 'Yes' : 'No',

    });
    this.analyticsService.selectedProductsTrack({ name: this.selectedProductCode })
    this.saveFormValues();
    this.analyticsService.selectedProductsTrack({ name: this.selectedProductCode })
    this.loaderService.handleSpinnerFlag({ show: true, onlyBackgroundFlag: true, Message: '', opacity: .4 });
    this.loadingFlag = true;
    if (this.isViewOnly) {
      this.loaderService.handleSpinnerFlag({ show: false, onlyBackgroundFlag: false, Message: '', opacity: .4 });
      this.loadingFlag = false;
      this.router.navigate(['/quote/your-saved-quotes']);
    } else {
      this.AgreeErrorValidatorFlag = !this.isAgreeSelected;
      this.signErrorValidatorFlag = !this.isSignSelected;
      if (this.yourProductApplicationForm.controls.chkAgree.value && this.yourProductApplicationForm.controls.chkSign.value) {
        this.applicationDatacaptureService.submitApplication(this.applicationRefNumber).subscribe(res => {
          this.loaderService.handleSpinnerFlag({ show: false, onlyBackgroundFlag: false, Message: '', opacity: .4 });
          this.loadingFlag = false;
          this.router.navigate(['/apply/congratulations']);
        });
      } else {
        this.loaderService.handleSpinnerFlag({ show: false, onlyBackgroundFlag: false, Message: '', opacity: .4 });
        this.loadingFlag = false;
        let agreeErrMessages = [];
        if(!this.yourProductApplicationForm.controls.chkAgree.value) {
          agreeErrMessages.push("Agreement Acceptance required")
        }

        if(!this.yourProductApplicationForm.controls.chkSign.value) {
          agreeErrMessages.push("Signing required")
        }
        FormValidationsService.analyticsTracker(agreeErrMessages, this.analyticsService)
        // FormValidationsService.validateAllFormFields(this.yourProductApplicationForm, this.analyticsService);
        setTimeout(() => {
          this.scrollInvalidForm();
        });
      }
    }
  }
  // method to scroll the form when form is invalid
  scrollInvalidForm() {
    const invalidElements = this.el.nativeElement.querySelectorAll('.form-validation-error');
    if (invalidElements.length > 0) {
      invalidElements[0].scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
    }
  }
  onSignCheckChange(e) {
    this.isSignSelected = e.target.checked;
    this.signErrorValidatorFlag = !this.isSignSelected;
    //this.marked= e.target.checked;
  }
  onBackClick() {
    // OnBackClick this method invokes
    this.saveFormValues();
  }
  // to hide or show fields based on product code
  getVisibility(visibility) {
    if (this.selectedProductCode === 'C') {
      return visibility[0];
    } else if (this.selectedProductCode === 'H') {
      return visibility[1];
    } else if (this.selectedProductCode === 'G') {
      return visibility[2];
    }
  }
  // capture selected quote data from Quote Journey
  quoteData() {
    if (this.selectedProductCode === 'C') {
      const objProductQuote = {
        pensionFund: this.resultQuote['pensionFund'],
        startDate: this.resultQuote['startDate'],
        indicative: this.resultQuote['indicative'],
        income: CommonUtilityService.formatIncome(this.resultQuote['paymentFrequency'], this.resultQuote['paymentAdvance']),
        incomeIncrease: CommonUtilityService.formatIncomeIncrease(this.resultQuote['escalationType'], this.resultQuote['escalationRate']),
        totalTaxFreeCashAmount: this.totalTaxFreeCash,
        incomeDependent: this.resultQuote['secondLifePensionPercentage'] ? this.resultQuote['secondLifePensionPercentage'] : 0,
        guaranteedTerm: this.resultQuote['guaranteedTerm'],
        guarantedPaymentPeriod: CommonUtilityService.formatGuarantedPaymentPeriod(this.resultQuote['guaranteedTerm']),
        valueProtection: this.resultQuote['vpPercentage'],
        valueProtectionAmount: this.resultQuote['vpAmount'],
        quoteExpiry: this.resultQuote['quoteExpiry'],
        monthlyIncome: this.resultQuote['annualIncome'] ? this.resultQuote['annualIncome'] / 12 : 0,
        annualIncome: this.resultQuote['annualIncome'] ? this.resultQuote['annualIncome'] : 0,
        padsRefNo: this.resultQuote['padsRefNo'],
        paymentFrequency: this.resultQuote['paymentFrequency'],
        selectedProduct: this.resultQuote['product'],
        fundingSource: (this.resultQuote['source']),
        quoteRefNo: this.resultQuote['quoteRefNo'],
        annuitantPension: 0,
        annuitantYearlyPension: 0,
        applicationId: this.resultQuote['applicationId'],
        productOptions: null,
        requoteInd: null,
        applyQuoteInd: null,
        garIndicator: this.resultQuote['garIndicator'],
        taxFreeCashAmountPercent: this.resultQuote['taxFreeCashAmountPercent'],
        vpIndicator: this.resultQuote['vpIndicator']
        // annuitantPension: this.selectedCard['annuitantPension'] ? this.selectedCard['annuitantPension'] : 0,
        // annuitantYearlyPension: this.selectedCard['annuitantYearlyPension'] ? this.selectedCard['annuitantYearlyPension'] : 0
      };
      this.Selectedproductquote = objProductQuote;
    }
    if (this.selectedProductCode === 'H') {
      const objProductQuote = {
        pensionFund: this.resultQuote['pensionFund'],
        //  startDate: this.resultQuote['startDate'],
        startDate: this.resultQuote['startDate'],
        indicative: this.resultQuote['indicative'],
        income: CommonUtilityService.formatIncome(this.resultQuote['paymentFrequency'], this.resultQuote['paymentAdvance']),
        incomeIncrease: CommonUtilityService.formatIncomeIncrease(this.resultQuote['escalationType'], this.resultQuote['escalationRate']),
        totalTaxFreeCashAmount: this.totalTaxFreeCash,
        incomeDependent: this.resultQuote['secondLifePensionPercentage'] ? this.resultQuote['secondLifePensionPercentage'] : 0,
        guaranteedTerm: this.resultQuote['guaranteedTerm'],
        guaranteedTermIndicator: this.resultQuote['guaranteedTermIndicator'],
        guarantedPaymentPeriod: CommonUtilityService.formatGuarantedPaymentPeriod(this.resultQuote['guaranteedTerm']),
        valueProtection: this.resultQuote['vpPercentage'],
        valueProtectionAmount: this.resultQuote['vpAmount'],
        quoteExpiry: this.resultQuote['quoteExpiry'],
        monthlyIncome: this.resultQuote['annualIncome'] ? this.resultQuote['annualIncome'] / 12 : 0,
        annualIncome: this.resultQuote['annualIncome'] ? this.resultQuote['annualIncome'] : 0,
        padsRefNo: this.resultQuote['padsRefNo'],
        paymentFrequency: this.resultQuote['paymentFrequency'],
        selectedProduct: this.resultQuote['product'],
        fundingSource: (this.resultQuote['source']),
        quoteRefNo: this.resultQuote['quoteRefNo'],
        annuitantYearlyPension: this.resultQuote['annualIncome'] ? this.resultQuote['annualIncome'] : 0,
        annuitantPension: this.resultQuote['annualIncome'] ? this.resultQuote['annualIncome'] / 12 : 0,
        annuitantMaturity: this.resultQuote['maturityValue'] ? this.resultQuote['maturityValue'] : 0,
        policyTerm: this.resultQuote['policyTerm'] ? this.resultQuote['policyTerm'] : 0,
        policyTermMonths: this.resultQuote['policyTermMonths'] ? this.resultQuote['policyTermMonths'] : 0,
        maturityAmount: this.resultQuote['maturityValue'] ? this.resultQuote['maturityValue'] : 0,
        initialAnnualIncome: this.resultQuote['annualIncome'] ? this.resultQuote['annualIncome'] : 0,
        giaCalculated: this.resultQuote['giaCalculated'] ? this.resultQuote['giaCalculated'] : null,
        applicationId: this.resultQuote['applicationId'],
        productOptions: null,
        requoteInd: null,
        applyQuoteInd: null
      };
      this.SelectedProductQuoteFTRP = objProductQuote;
    }
    if (this.selectedProductCode === 'G') {
      const objProductQuote = {
        pensionFund: this.resultQuote['pensionFund'],
        //  startDate: this.resultQuote['startDate'],
        startDate: this.resultQuote['startDate'],
        indicative: this.resultQuote['indicative'],
        income: CommonUtilityService.formatIncome(this.resultQuote['paymentFrequency'], this.resultQuote['paymentAdvance']),
        incomeIncrease: CommonUtilityService.formatIncomeIncrease(this.resultQuote['escalationType'], this.resultQuote['escalationRate']),
        totalTaxFreeCashAmount: this.totalTaxFreeCash,
        incomeDependent: this.resultQuote['secondLifePensionPercentage'] ? this.resultQuote['secondLifePensionPercentage'] : 0,
        guaranteedTerm: this.resultQuote['guaranteedTerm'],
        guarantedPaymentPeriod: CommonUtilityService.formatGuarantedPaymentPeriod(this.resultQuote['guaranteedTerm']),
        valueProtection: this.resultQuote['vpPercentage'],
        valueProtectionAmount: this.resultQuote['vpAmount'],
        quoteExpiry: this.resultQuote['quoteExpiry'],
        monthlyIncome: this.resultQuote['annualIncome'] ? this.resultQuote['annualIncome'] / 12 : 0,
        annualIncome: this.resultQuote['annualIncome'] ? this.resultQuote['annualIncome'] : 0,
        padsRefNo: this.resultQuote['padsRefNo'],
        paymentFrequency: this.resultQuote['paymentFrequency'],
        selectedProduct: this.resultQuote['product'],
        fundingSource: (this.resultQuote['source']),
        quoteRefNo: this.resultQuote['quoteRefNo'],
        annuitantYearlyPension: this.resultQuote['annualIncome'] ? this.resultQuote['annualIncome'] : 0,
        annuitantPension: this.resultQuote['annualIncome'] ? this.resultQuote['annualIncome'] / 12 : 0,
        policyTerm: this.resultQuote['policyTerm'] ? this.resultQuote['policyTerm'] : 0,
        policyTermMonths: this.resultQuote['policyTermMonths'] ? this.resultQuote['policyTermMonths'] : 0,
        applicationId: this.resultQuote['applicationId'],
        productOptions: null,
        requoteInd: null,
        applyQuoteInd: null
      };
      this.SelectedProductQuoteCORP = objProductQuote;
    }
  }

  // product details captured from both QuoteResultModel and CedingFund(Apply)
  getProductDetails(label, controlName) {
    let value;
    let amt = 0;
    switch (label) {
      // total pension fund choosen in apply journey
      case this.productDetailsSection[0].section[0].label:
        if (this.responseApplicationData['cedingPension'] && this.responseApplicationData['cedingPension'].length > 0) {
          this.responseApplicationData['cedingPension'].forEach(element => {
            if (this.resultQuote['isGMP'] === quoteLevelConstants.radioToggleYesNo.yes || DealPartnerFunctionalityService.isGARProduct(this.resultQuote['garIndicator'])) {
              amt = (this.responseApplicationData['quoteFundInfo'] && this.responseApplicationData['quoteFundInfo'][0] &&
                this.responseApplicationData['quoteFundInfo'][0]['totalQuoteFund'] ? this.responseApplicationData['quoteFundInfo'][0]['totalQuoteFund'] : null);
            } else {
              amt = element.fundValue ? (element.fundValue + amt) : null;
            }
          });
        }
        value = (amt === null) ? null : this.formatCurrency(amt);
        break;
      case this.productDetailsSection[0].section[1].label:
        // total TFC(ext if selected) choosen in apply journey
        if (this.responseApplicationData['cedingPension'] &&  this.responseApplicationData['cedingPension'].length > 0) {
          this.responseApplicationData['cedingPension'].forEach(element => {
            if (this.resultQuote['isGMP'] === quoteLevelConstants.radioToggleYesNo.yes || DealPartnerFunctionalityService.isGARProduct(this.resultQuote['garIndicator'])) {
              amt = (this.responseApplicationData['quoteFundInfo'] && this.responseApplicationData['quoteFundInfo'][0] &&
                this.responseApplicationData['quoteFundInfo'][0]['totalTfc'] ? this.responseApplicationData['quoteFundInfo'][0]['totalTfc'] : null);
            } else {
              amt = amt + ((element.tfcAmt !== '0' && element.tfcAmt !== null) ? Number(element.tfcAmt) : 0) +
                ((element.extTfcAmt !== '0' && element.extTfcAmt !== null) ? Number(element.extTfcAmt) : 0);
            }
          });
        }
        value = (amt === null) ? null : this.formatCurrency(amt);
        break;
      case this.productDetailsSection[1].section[0].label:
        // commencementDate captured from QuoteJourney
        value = this.responseApplicationData['quoteFundInfo'][0].commencementDate;
        // value = value.replace(/\//g, '.');
        break;
      case this.productDetailsSection[1].section[1].label:
        // Term captured from QuoteJourney
        if (this.resultQuote['policyTermMonths'] !== null && this.resultQuote['policyTerm'] !== null) {
          value = this.resultQuote['policyTerm'] + ' ' + this.generalConstants.years +
            (this.resultQuote['policyTermMonths'] > 0 ? ', ' + this.resultQuote['policyTermMonths'] + ' ' +
              (this.resultQuote['policyTermMonths'] > 1 ? this.generalConstants.months : this.generalConstants.month) : '');
        } else if (this.resultQuote['policyTermMonths'] !== null || this.resultQuote['policyTerm'] !== null) {
          value = this.resultQuote['policyTerm'] !== null ?
            // tslint:disable-next-line:max-line-length
            this.resultQuote['policyTerm'] + ' ' + this.generalConstants.years +
            (this.resultQuote['policyTermMonths'] > 0 ? ', ' + this.resultQuote['policyTermMonths'] + ' ' +
              (this.resultQuote['policyTermMonths'] > 1 ? this.generalConstants.months : this.generalConstants.month) : '')
            // tslint:disable-next-line:max-line-length
            : (this.resultQuote['policyTermMonths'] !== null && this.resultQuote['policyTermMonths'] > 0 ? ', ' + this.resultQuote['policyTermMonths'] + ' ' +
              (this.resultQuote['policyTermMonths'] > 1 ? this.generalConstants.months : this.generalConstants.month) : '');
        }
        // value = (this.resultQuote['policyTermMonths'] || this.resultQuote['policyTerm']) ?
        //   // tslint:disable-next-line:max-line-length
        //   this.resultQuote['policyTerm'] + ' ' + this.generalConstants.years + ', ' + this.resultQuote['policyTermMonths'] + ' ' +
        //   (this.resultQuote['policyTermMonths'] > 1 ? this.generalConstants.months : this.generalConstants.month) :
        //   this.resultQuote['policyTerm'] + ' ' + this.generalConstants.years;
        break;
      case this.productDetailsSection[1].section[2].label:
        // maturity value captured from QuoteJourney
        value = this.formatCurrency(this.resultQuote['maturityValue']);
        break;
      case this.productDetailsSection[2].section[0].label:
        // income captured from QuoteJourney
        value = CommonUtilityService.formatIncome(this.resultQuote['paymentFrequency'], this.resultQuote['paymentAdvance']);
        /* this.resultQuote['annualIncome'] && this.resultQuote['annualIncome'] === 0 ? 'None' : 
          this.formatCurrency(this.resultQuote['annualIncome']) + ' ' +
          CommonUtilityService.formatIncome(this.resultQuote['paymentFrequency'], this.resultQuote['paymentAdvance']); */
        break;
      case this.productDetailsSection[2].section[2].label:
        // dependant income captured from QuoteJourney
        value = this.resultQuote['vpIndicator'] === 'Ann' ? 'Not provided' : (this.resultQuote['secondLifePensionPercentage']
          ? this.resultQuote['secondLifePensionPercentage'] : '0') + '%';
        break;
      case this.productDetailsSection[2].section[1].label:
        // increased income captured from QuoteJourney
        value = this.resultQuote['escalationType'] === 'R' ? 'RPI' :
          CommonUtilityService.formatIncomeIncrease(this.resultQuote['escalationType'], this.resultQuote['escalationRate']);
        // CommonUtilityService.formatIncomeIncrease(this.resultQuote['escalationType'], this.resultQuote['escalationRate']);
        break;
      case this.productDetailsSection[2].section[3].label:
        // guaranteed payment captured from QuoteJourney
        if (this.selectedProductCode === 'C') {
          value = (this.resultQuote['guaranteedTerm'] && this.resultQuote['guaranteedTerm'] > 1 ? (this.resultQuote['guaranteedTerm']
            + ' ' + this.generalConstants.years) : (this.resultQuote['guaranteedTerm'] && this.resultQuote['guaranteedTerm']
              === 1 ? this.resultQuote['guaranteedTerm'] + ' ' + this.generalConstants.year : null));
        } else {
          value = (this.resultQuote['guaranteedTermIndicator'] === 'O' ?
            this.resultQuote['guaranteedTerm'] : (this.resultQuote['guaranteedTermIndicator'] === 'N' ? 'None' : 'Whole term')) +
            (this.resultQuote['guaranteedTermIndicator'] === 'O' ?
              (this.resultQuote['guaranteedTerm'] > 1 ? (' ' + this.generalConstants.years)
                : (this.resultQuote['guaranteedTerm'] === 1 ? (' ' + this.generalConstants.year) : null)) : '');
        }
        break;
      case this.productDetailsSection[2].section[4].label:
        // value protection benefit captured from QuoteJourney
        if (this.selectedProductCode === 'C') {
          value = this.resultQuote['vpIndicator'] === 'Y' ? (this.resultQuote['vpPercentage'] + this.cmsDataProductQuote.percentage) : '';
        }
        break;
    }

    return value;
  }
  formatCurrency = (val) => {
    const reg = new RegExp('^-?\\d+(?:\.\\d{0,' + (2 || -1) + '})?');
    let formattedCurrency = val.toString().match(reg)[0];
    formattedCurrency = parseFloat(formattedCurrency).toFixed(2);
    const formattedValue = '£' + CurrencyFunctionalityService.convertNumberToCurrency(formattedCurrency);
    return formattedValue;
  }

  // update visibility of certain fields based on the store values
  updateVisibility() {
    // updating the visibility of Income to Dependant field based on Dependant-selection in Quote Journey
    this.productDetailsSection[2].section[2].visibility[0] = (this.selectedProductCode === 'C' &&
      this.resultQuote['secondLifePensionPercentage'] !== null && 
      this.resultQuote['isGMP'] !== quoteLevelConstants.radioToggleYesNo.yes) ? true : false;
    // updating the visibility of TFC field
    if (this.responseApplicationData['cedingPension'] && this.responseApplicationData['cedingPension'].length > 0) {
      // let amt;
      let count = 0;
      this.responseApplicationData['cedingPension'].find(element => {
        if (this.resultQuote['isGMP'] === quoteLevelConstants.radioToggleYesNo.yes || DealPartnerFunctionalityService.isGARProduct(this.resultQuote['garIndicator'])) {
          count = ((this.responseApplicationData['quoteFundInfo'] && this.responseApplicationData['quoteFundInfo'][0]) &&
            (this.responseApplicationData['quoteFundInfo'][0]['totalTfc'] === 0 ||
              this.responseApplicationData['quoteFundInfo'][0]['totalTfc'] === null)) ? count : (count + 1);
          //count = (element.tfcAmt === '0' || element.tfcAmt === null) ? count : (count + 1);
        } else {
          count = ((element.tfcAmt === '0' || element.tfcAmt === null) &&
            (element.extTfcAmt === '0' || element.extTfcAmt === null)) ? count : (count + 1);
        }
      });
      this.productDetailsSection[0].section[1].visibility[0] = count > 0 ? true : false;
      this.productDetailsSection[0].section[1].visibility[1] = count > 0 ? true : false;
      this.productDetailsSection[0].section[1].visibility[2] = count > 0 ? true : false;
    }
    // guaranteed payment for FTRP and LTA (only if selected and GTermIndicator is not None)
    // tslint:disable-next-line:max-line-length
    this.productDetailsSection[2].section[3].visibility[0] = this.resultQuote['guaranteedTerm'] && this.resultQuote['guaranteedTerm'] !== null ? true : false;
    // tslint:disable-next-line:max-line-length
    this.productDetailsSection[2].section[3].visibility[1] = this.resultQuote['guaranteedTerm'] && this.resultQuote['guaranteedTerm'] !== null ? true : false;

    // income increase
    this.productDetailsSection[2].section[1].visibility[0] = (this.resultQuote['isGMP'] === quoteLevelConstants.radioToggleYesNo.yes || DealPartnerFunctionalityService.isGARProduct(this.resultQuote['garIndicator'])) ||
      this.resultQuote['escalationType'] === 'N' ? false : true;
    // tslint:disable-next-line:max-line-length
    this.productDetailsSection[1].section[1].visibility[2] = this.resultQuote['policyTerm'] || this.resultQuote['policyTermMonths'] ? true : false;
    this.productDetailsSection[2].section[4].visibility[0] = this.responseApplicationData['quoteFundInfo'][0]['valueProtection'] === true
      ? true : false;
  }
  /* defect# 3265 - method to return the product detail's section visibility */
  getSectionVisibility(section, productCode) {
    let index;
    index = productCode === 'C' ? 0 : (productCode === 'H' ? 1 : 2);
    if (section[0].visibility[index] === false && section[1].visibility[index] === false
      && section[2].visibility[index] === false) {
      return false;
    } else {
      return true;
    }
  }

  /** Code block for CMS */
  GetCMSDataServiceMapper() {
    if (this.CMSData) {
      /** In the line below we are over-writing the contentData object values with CMSData object values */
      this.cmsData1.keyFeature1 = this.CMSData.pdfBlock.string_OpenQuotePdfCTALabel;
      this.cmsData1.keyFeature2 = this.CMSData.pdfBlock.string_KeyfeaturesPdfTitle;
      this.cmsData1.keyFeature3 = this.CMSData.pdfBlock.string_TermsandConditionsPdfTitle;
      this.cmsData1.keyFeature4 = this.CMSData.pdfBlock.string_OpenPensionScamsPdfCTALabel;
      //this.userInputDetail['buttonConfig'].name = this.CMSData.commonBlock.string_NextCTALabel;
      if (this.resultQuote['isGMP'] === quoteLevelConstants.radioToggleYesNo.yes) {
        this.contentData.header = this.CMSData.stringGroup_ProductOptionsGMP.string_YourProductTitle_1 + ' ' +
         this.CMSData.stringGroup_ProductOptionsGMP.string_GMPProductName + ' ' +
         this.CMSData.stringGroup_ProductOptionsGMP.string_Application;
      } else if (DealPartnerFunctionalityService.isGARProduct(this.resultQuote['garIndicator'])) {
        this.contentData.header = this.CMSData.stringGroup_ProductOptionsGAR.string_YourProductTitle_1 + ' ' +
        this.CMSData.stringGroup_ProductOptionsGAR.string_GARProductName + ' ' +
        this.CMSData.stringGroup_ProductOptionsGAR.string_Application;
      } else {
        this.contentData.header = (this.selectedProductCode === 'C') ? this.CMSData.stringGroup_ProductOptionsPensionAnnuityAppTitle
          : (this.selectedProductCode === 'H' ? this.CMSData.stringGroup_ProductOptionsFtrpApplyTitle
            : this.CMSData.stringGroup_ProductOptionsCorpApplyTitle);
      }
      this.contentData.introduction = this.CMSData.string_ProductSummaryWording;
      this.contentData.productDetailsHeader = this.CMSData.string_ProductDetails;
      this.contentData.disclosureStatement = this.CMSData.string_MedicalDisclosureWording;
      this.contentData.reminderStatement = this.CMSData.string_SummaryWording;
      this.contentData.btnViewSummary = this.CMSData.string_ViewSummaryCTALabel;
      this.contentData.confirmText = this.CMSData.string_ConfirmSignSubmitTitle;
      // this.declarationSection.declarationTextGI = this.CMSData.string_declarationTextGI;
      this.declarationSection.introductionText = this.CMSData.string_SeriousOffenceWording;
      this.declarationSection.html_GI_DeclarationWording = this.CMSData.html_GI_DeclarationWording;
      // tslint:disable-next-line:max-line-length
      this.declarationSection.html_GI_DeclarationWording = this.declarationSection.html_GI_DeclarationWording.replace(/{}/g, this.selectedProductName);
      if(!this.applicationDatacaptureService.showContent(this.responseApplicationData['applicationSubmissionDate'])) {
        if(this.declarationSection.html_GI_DeclarationWording.includes("<br/><br/><span class='text-style-2'>B. Lifetime allowance declaration</span><br/><br/>")){
          this.declarationSection.html_GI_DeclarationWording = this.declarationSection.html_GI_DeclarationWording.slice(0,this.declarationSection.html_GI_DeclarationWording.indexOf("<br/><br/><span class='text-style-2'>B. Lifetime allowance declaration</span><br/><br/>"));
        }
        
      }
      this.declarationSection.html_LTADP_DeclarationWording = this.CMSData.html_LTA_DeclarationWording;
      this.declarationSection.agreeText = this.CMSData.string_AgreeToTerms;
      this.formCompletionSection.header = this.CMSData.string_MarketingConsentTitle;
      this.formCompletionSection.introduction = this.CMSData.string_MarketingConsentWording;
      this.formCompletionSection.exampleInfo = this.CMSData.string_EgOnlineMarketing;
      this.formCompletionSection.withdrawText = this.CMSData.string_MarketingPrivacyPolicy.replace('<a', '<a class="a-color"');
      this.formCompletionSection.reviewText1 = this.CMSData.string_MarketingReviewDetailsWording;
      this.formCompletionSection.reviewText2 = this.CMSData.string_MarketingReviewDetailsWording2;
      this.contentData.clickSignText = this.CMSData.string_ClickToSignLabel;
      this.afterApplyDetail['buttonConfigProductApplication'].label = this.isViewOnly ?
        this.CMSData.commonBlock.string_BackToMyQuotesCTALabel : this.CMSData.string_SubmitApplicationCTALabel;
      this.submitCTAlabel = this.CMSData.string_SubmitApplicationCTALabel;
      this.backToMyQuotesCTA = this.CMSData.commonBlock.string_BackToMyQuotesCTALabel;

      /** PDF Mappers */
     if (this.resultQuote['isGMP'] === quoteLevelConstants.radioToggleYesNo.yes) {
        this.selectedProductInfo.documentLink.find(k => k['key'] === 'keyFeatures').urlArray.find(ele =>
          DealPartnerFunctionalityService.isDealPartnerWithoutProductCode(ele['fundingSource'])).url =
          this.CMSData.pdfBlock.pruURL_Q0059291;
        this.selectedProductInfo.documentLink.find(k => k['key'] === 'keyFeatures').urlArray.find(ele =>
          ele['fundingSource'] === 'H').url = this.CMSData.pdfBlock.aegonURL_Q0054471;
        this.selectedProductInfo.documentLink.find(k => k['key'] === 'keyFeatures').urlArray.find(ele =>
          ele['fundingSource'] === 'F').url = this.configLoaderService.configuration.isSlocRemoved ? this.CMSData.pdfBlock.PhoenixPA_KFD_DA2124 : this.CMSData.pdfBlock.slocURL_W13830;
        this.selectedProductInfo.documentLink.find(k => k['key'] === 'keyFeatures').urlArray.find(ele =>
          ele['fundingSource'] === 'J').url = this.CMSData.pdfBlock.reAssureURL_Q0059211;
        this.selectedProductInfo.documentLink.find(k => k['key'] === 'keyFeatures').urlArray.find(ele =>
          ele['fundingSource'] === 'O').url = this.CMSData.pdfBlock.PhoenixPA_KFD_DA2124;
          // tslint:disable-next-line:max-line-length
        this.cmsProductChoice.products.find(response => response.productCode === 'C').documentLink.find(res => res.name === 'Terms and conditions').url =
          this.resultQuote['source'] === 'H' ? this.CMSData.pdfBlock.aegonGARGMPURL_Q0054812 : this.CMSData.pdfBlock.gargmpUrl_S430;
      } else if (DealPartnerFunctionalityService.isGARProduct(this.resultQuote['garIndicator'])) {
        this.selectedProductInfo.documentLink.find(k => k['key'] === 'keyFeatures').urlArray.find(ele =>
          DealPartnerFunctionalityService.isDealPartnerWithoutProductCode(ele['fundingSource'])).url =
          this.CMSData.pdfBlock.pruURL_Q0059291;
        this.selectedProductInfo.documentLink.find(k => k['key'] === 'keyFeatures').urlArray.find(ele =>
          ele['fundingSource'] === 'H').url = this.CMSData.pdfBlock.aegonURL_Q0054471;
        this.selectedProductInfo.documentLink.find(k => k['key'] === 'keyFeatures').urlArray.find(ele =>
          ele['fundingSource'] === 'F').url = this.configLoaderService.configuration.isSlocRemoved ? this.CMSData.pdfBlock.PhoenixPA_KFD_DA2124 : this.CMSData.pdfBlock.slocURL_W13830;
        this.selectedProductInfo.documentLink.find(k => k['key'] === 'keyFeatures').urlArray.find(ele =>
          ele['fundingSource'] === 'O').url = this.CMSData.pdfBlock.PhoenixPA_KFD_DA2124;
        this.selectedProductInfo.documentLink.find(k => k['key'] === 'keyFeatures').urlArray.find(ele =>
          ele['fundingSource'] === 'J').url = this.CMSData.pdfBlock.reAssureURL_Q0059211;
        // tslint:disable-next-line:max-line-length
        this.cmsProductChoice.products.find(response => response.productCode === 'C').documentLink.find(res =>
          res.name === 'Terms and conditions').url = this.CMSData.pdfBlock.gargmpUrl_S430;
      } else {
        this.selectedProductInfo.documentLink.find(k => k['key'] === 'keyFeatures').urlArray.find(ele =>
          ele['fundingSource'] === 'I').url = this.selectedProductCode === 'H' ? this.CMSData.pdfBlock.ftrpUrl_TKFQ0050898
            : (this.selectedProductCode === 'C' ? this.CMSData.pdfBlock.externalUrl_InternalDirectKfQ56658 : this.CMSData.pdfBlock.corpUrl_KFQ0050893);
        this.selectedProductInfo.documentLink.find(k => k['key'] === 'keyFeatures').urlArray.find(ele =>
          ele['fundingSource'] === 'B').url = this.selectedProductCode === 'H' ? this.CMSData.pdfBlock.ftrpUrl_TKFQ0050898
            : (this.selectedProductCode === 'G') ? this.CMSData.pdfBlock.corpUrl_KFQ0050893: this.CMSData.pdfBlock.externalUrl_ExternalDirectKfQ56658;
        if (this.selectedProductCode === 'C') {
          this.selectedProductInfo.documentLink.find(k => k['key'] === 'keyFeatures').urlArray.find(ele =>
            DealPartnerFunctionalityService.isDealPartnerWithoutProductCode(ele['fundingSource'])).url =
            this.CMSData.pdfBlock.externalUrl_ExternalDirectKfQ56658;
        }
        this.selectedProductInfo.documentLink.find(k => k['key'] === 'keyFeatures').urlArray.find(ele =>
          ele['fundingSource'] === 'H').url = this.selectedProductCode === 'H' ?
            this.CMSData.pdfBlock.ftrpUrl_TKFQ0050898 : this.CMSData.pdfBlock.externalUrl_AegonSltaKfQ58798;
        this.selectedProductInfo.documentLink.find(k => k['key'] === 'keyFeatures').urlArray.find(ele =>
          ele['fundingSource'] === 'F').url = this.selectedProductCode === 'H' ?
            this.CMSData.pdfBlock.ftrpUrl_TKFQ0050898 : (this.selectedProductCode === 'G') ? this.CMSData.pdfBlock.corpUrl_KFQ0050893: (this.configLoaderService.configuration.isSlocRemoved ? this.CMSData.pdfBlock.PhoenixSimpPA_KFD_DA2125 : this.CMSData.pdfBlock.externalUrl_SlocSltaKfQ58799);
        this.selectedProductInfo.documentLink.find(k => k['key'] === 'keyFeatures').urlArray.find(ele =>
          ele['fundingSource'] === 'J').url = this.selectedProductCode === 'H' ?
            this.CMSData.pdfBlock.ftrpUrl_TKFQ0050898 : this.CMSData.pdfBlock.externalUrl_ReassureSltaKfQ59212;
        this.selectedProductInfo.documentLink.find(k => k['key'] === 'keyFeatures').urlArray.find(ele =>
          ele['fundingSource'] === 'O').url = this.selectedProductCode === 'H' ?
            this.CMSData.pdfBlock.ftrpUrl_TKFQ0050898 : (this.selectedProductCode === 'G') ? this.CMSData.pdfBlock.corpUrl_KFQ0050893 : this.CMSData.pdfBlock.PhoenixSimpPA_KFD_DA2125;
        this.cmsProductChoice.products.find(response => response.productCode === 'C').documentLink.find(res =>
          res.name === 'Terms and conditions').url = this.CMSData.pdfBlock.externalUrl_TermsConditionsQ56660;
      }
      if ((this.selectedProductCode === 'H' || this.selectedProductCode === 'G') && this.resultQuote &&  this.resultQuote['source'] == 'J') {
        this.selectedProductInfo.documentLink.find(k => k['key'] === 'keyFeatures').urlArray.find(ele =>
          ele['fundingSource'] === 'J').url = this.selectedProductCode === 'H' ?
          this.CMSData.pdfBlock.reAssureFTRP_KFDURL_Q0059214 : this.CMSData.pdfBlock.reAssureCORP_KFDURL_Q0059217;        
      }
      this.declarationSection.declarationTextGI = this.CMSData.string_declarationTextGI;
      this.declarationSection.declarationText = this.CMSData.string_declarationText;
      this.declarationSection.scrollText = this.CMSData.string_scrollText;
      this.contentData.application = this.CMSData.string_Application;
      /* T&C's Mapping for FTRP/CORP : defect 8062 */
      if (this.selectedProductCode === 'H' || this.selectedProductCode === 'G') {
        this.cmsProductChoice.products.find(response => response.productCode === this.selectedProductCode).documentLink.find(res =>
          res.name === 'Terms and conditions').url = this.selectedProductCode === 'H' ? this.CMSData.pdfBlock.ftrpUrl_TermsConditionsQ0050905
            : this.CMSData.pdfBlock.corPlUrl_TermsConditionsQ0050902;
      }
    }
  }
  /** End of code block for CMS */
}
